import _filter from 'lodash/filter'
import _map from 'lodash/map'
import _sortBy from 'lodash/sortBy'

import axios from '../../_framework/axios/trip-dashboard-axios'

export default {
  getters: {
    ToDoItems: (state, getters) => {
      let todoItems = getters.currentTripDashboardId
        ? _sortBy(getters.Trips[getters.currentTripDashboardId].todo_items, function (item) {
            return item.actual_due_date
          })
        : []

      todoItems = _map(todoItems, todoItem => {
        todoItem.attachments = _map(todoItem.attachments, attachmentOrAttachmentId => {
          return Number.isInteger(attachmentOrAttachmentId)
            ? attachmentOrAttachmentId
            : attachmentOrAttachmentId.id
        })
        return todoItem
      })

      return todoItems
    },
    incompleteTodoItems: (state, getters) => {
      return _filter(getters.ToDoItems, function (i) {
        return !i.done
      })
    },
    completeTodoItems: (state, getters) => {
      return _filter(getters.ToDoItems, function (i) {
        return i.done
      })
    }
  },
  actions: {
    refreshTodoList(context) {
      axios.get(`${context.getters.currentTripDashboardId}/getTodoAndEvents`).then(response => {
        if (response.status === 200) {
          context.commit('updateTripEventsAndTodoItems', response.data)
        }
      })
    },
    upsertTodoItem(context, payload) {
      if (this.getters.isOperator) {
        axios
          .post(`${context.getters.currentTripDashboardId}/upsertTodoItem`, payload)
          .then(response => {
            if (response.status === 200) {
              context.commit('updateTripEventsAndTodoItems', response.data)
            }
          })
      }
    },
    removeTodoItem(context, payload) {
      if (this.getters.isOperator) {
        axios
          .post(`${context.getters.currentTripDashboardId}/removeTodoItem`, payload)
          .then(response => {
            if (response.status === 200) {
              context.commit('updateTripEventsAndTodoItems', response.data)
            }
          })
      }
    },
    toggleTodoItem(context, payload) {
      axios
        .post(`${context.getters.currentTripDashboardId}/toggleTodoItem`, payload)
        .then(response => {
          if (response.status === 200) {
            context.commit('updateTripEventsAndTodoItems', response.data)
          }
        })
    }
  }
}
